import { Box, Button, Switch, Typography } from "@mui/material";
import {
  DataGrid,
  gridClasses,
  GridToolbarContainer,
  GridToolbarFilterButton,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";

const OrgUsers = () => {
  const [users, setUsers] = useState([]);
  const [org, setOrg] = useState()
  const { orgId } = useParams();
  const admin = JSON.parse(localStorage.getItem("admin"));
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();

  useEffect(() => {
    const getOrg = async () => {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/organization/get-by-admin?username=${admin}`,
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      if (
        !res.data.orgLogo &&
        !res.data.orgUsername &&
        !res.data.orgShortform
      ) {
        navigate(`/superadmin-dashboard/${orgId}/admin-dashboard/org-details`);
      } else {
        setOrg(res.data)
      }
    };
    getOrg();
  }, []);

  useEffect(() => {
    const getOrgUsers = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/org-user/all?orgId=${orgId}&username=${admin}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setUsers(res.data);
      } catch (error) {
        console.log(error.response.data.Exception || "Access denied");
      }
    };
    getOrgUsers();
  }, []);

  const columns = [
    {
      field: "orgUserId",
      headerName: "Org User ID",
      flex: 1,
    },
    {
      field: "name",
      headerName: "Name",
      flex: 1,
    },
    {
      field: "email",
      headerName: "Email",
      flex: 1,
    },
    {
      field: "userRoleName",
      headerName: "User Role Name",
      flex: 1,
      renderCell: (params) => params.row.userRoleName.replace("_", " "),
    },
    {
      field: "action",
      headerName: "Enable/Disable",

      width: 200,
      renderCell: (params) => (
        <Switch
          defaultChecked={params.row.isEnable}
          onClick={() =>
            handleEnableDisable(params.row.orgUserId, params.row.isEnable)
          }
        />
      ),
    },
  ];

  const rows = users ? users : "";

  const handleEnableDisable = async (orgUserId, isEnable) => {
    try {
      const res = await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/org-user?orgUserId=${orgUserId}`,
        {
          isEnable: !isEnable,
        },
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <div>
        <div>
            <Typography sx={{fontWeight: 'bold'}}>Organization: {org && org.orgName}</Typography>
            <Typography sx={{fontWeight: 'bold'}}>Admin Email: {org && org.adminEmail}</Typography>
        </div>
      <div style={{ display: "flex", justifyContent: "end", gap: 10 }}>
        <Button
          className="btn-contained"
          onClick={() => navigate(`/superadmin-dashboard/${orgId}/admin-dashboard/vendor`)}
        >
          Vendors
        </Button>
        <Button
          className="btn-contained"
          onClick={() => navigate(`/superadmin-dashboard/${orgId}/admin-dashboard/currency`)}
        >
          Currency
        </Button>
        <Button
          className="btn-contained"
          onClick={() => navigate(`/superadmin-dashboard/${orgId}/admin-dashboard/department`)}
        >
          Departments
        </Button>
        <Button
          className="btn-contained"
          onClick={() => navigate(`/superadmin-dashboard/${orgId}/admin-dashboard/create-user`)}
        >
          + Add User
        </Button>
      </div>
      <div className="dashboard-container">
        <h1>List of Users</h1>
        <Box sx={{ background: "#fff" }}>
          <DataGrid
            rows={rows}
            columns={columns}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 20,
                },
              },
            }}
            pageSizeOptions={[20]}
            disableRowSelectionOnClick
            disableColumnSelector
            disableDensitySelector
            slots={{ toolbar: CustomToolbar }}
            getRowId={(row) => row.orgUserId}
            getRowClassName={(params) =>
              params.indexRelativeToCurrentPage % 2 === 0 ? "even" : "odd"
            }
            sx={{
              position: "relative",
              border: "none",
              fontFamily: "Inter !important",

              "& .MuiDataGrid-columnHeaderTitle": {
                fontWeight: "700 !important",
              },
              "& .MuiDataGrid-columnHeaders": {
                background: "none !important",
                color: "black",
                fontSize: "14px",
                borderRadius: "10px",
              },
              "& .MuiDataGrid-row:hover": {
                backgroundColor: "#fff",
              },
              "& .MuiDataGrid-cell": {
                fontSize: "13px",
                border: "none",
              },
              "& .MuiDataGrid-columnSeparator": {
                display: "none",
              },
              "& .css-1ccsd5i-MuiButtonBase-root-MuiButton-root": {
                color: "#000 !important",
                border: "1px solid #B0B0B0",
                borderRadius: "12px",
                padding: 1,
              },
              "& .MuiInputBase-root-MuiInput-root::after": {
                borderBottom: "none !important",
              },
              "& .MuiInputBase-root-MuiInput-root": {
                borderBottom: "none !important",
              },
              [`& .${gridClasses.row}.even`]: {
                backgroundColor: "#EAF4FF",
                // '&:hover': {
                //   backgroundColor: "#f6f6f6",
                // },
              },
              "& .MuiInput-underline:before": {
                borderBottom: "none !important",
              },
              "& .css-5h82ro-MuiInputBase-root-MuiInput-root::after": {
                borderBottom: "none !important",
              },
            }}
          />
        </Box>
      </div>
    </div>
  );
};

export default OrgUsers;

function CustomToolbar() {
  return (
    <GridToolbarContainer sx={{ display: "flex", justifyContent: "end" }}>
      <GridToolbarQuickFilter
        sx={{
          border: "1px solid #B0B0B0",
          borderRadius: "12px",
          padding: "4px 12px",
          "&:hover": {
            backgroundColor: "#D8E9F0",
          },
          "& .MuiInputBase-root": {
            borderRadius: "12px",
          },
          width: 300,
        }}
      />
      {/* <GridToolbarFilterButton /> */}
    </GridToolbarContainer>
  );
}
